//#region Imports
import React from 'react';
//Foramtes date
import {format} from 'date-fns';
//#endregion

/**
* It is written in Directions>>TripLeg>>LegHeader
* Returns Leg Header.
* Function is used in renderStartingDirections and renderDirections of Directions>>TripLeg Component.
* @param {Object} 'Leg Detail'
* @return {HTMLElement} Leg Header
*/
const LegHeader = props => {
    //Stores start time and leg header
    const { time, heading } = props;
    return (
        <div className="otp-trip-leg-header">
            <div className="otp-trip-time">{format(time, 'h:mm a')}</div>
            <div className="otp-trip-divider"></div>
            <div className="otp-trip-text">{heading}</div>
        </div>
    );
};

export default LegHeader;